import { render, staticRenderFns } from "./PermissionUser.vue?vue&type=template&id=c45737ea&scoped=true"
import script from "./PermissionUser.vue?vue&type=script&lang=js"
export * from "./PermissionUser.vue?vue&type=script&lang=js"
import style0 from "./PermissionUser.vue?vue&type=style&index=0&id=c45737ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45737ea",
  null
  
)

export default component.exports